import { render, staticRenderFns } from "./categoryBreakdown.vue?vue&type=template&id=f7284fa2&scoped=true"
import script from "./categoryBreakdown.js?vue&type=script&lang=js&external"
export * from "./categoryBreakdown.js?vue&type=script&lang=js&external"
import style0 from "./categoryBreakdown.vue?vue&type=style&index=0&id=f7284fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7284fa2",
  null
  
)

export default component.exports